import React, { JSX } from 'react';
import { ListRowItem, SimpleListProps, Sorting } from './types';

const smallGroup = 'Kleingruppenreise';
const miniGroup = 'Minigruppenreise';

const TableHead = <L extends ListRowItem>({
  headItems,
  currentSorting,
  onSortClick
}: {
  headItems: SimpleListProps<L>['headItems'];
  currentSorting: Sorting;
  onSortClick: (sortProp: string, isAscDirection?: boolean) => void;
}): JSX.Element => {
  return (
    <thead className="simple-list__head">
      <tr>
        {headItems.map(item => (
          <th
            key={item.value}
            className={`simple-list__head-item${
              !!item.sortProp ? ' simple-list__head-item--sortable' : ''
            }${
              !!item.sortProp && item.sortProp === currentSorting.sortProp
                ? ' simple-list__head-item--sorting-active'
                : ''
            }${item.value === smallGroup || item.value === miniGroup ? '--groupSize' : ''}`}
            onClick={
              item.value !== smallGroup && !!item.sortProp
                ? (): void => onSortClick(item.sortProp || '')
                : undefined
            }
          >
            <span>{item.value === smallGroup || item.value === miniGroup ? '' : item.value}</span>
            {!!item.sortProp && item.sortProp === currentSorting.sortProp && (
              <span
                className={`simple-list__sort-icon${
                  !currentSorting.isAscDirection ? ' simple-list__sort-icon--flipped' : ''
                }`}
              />
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHead;
